import React from 'react';
import {
  Grid, SvgIcon, Box, Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import BaseModal from 'src/components/Modal/BaseModal';
import { FEATHER_ICONS } from 'src/constants/constants';
import IconRenderer from 'src/components/IconRenderer';


const useStyles = makeStyles((theme) => ({
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    cursor: 'pointer',
  },
}));

const FeatherIconPicker = ({ handleSelectIcon, onClose, isOpen }: any) => {
  const classes = useStyles();

  return (
    <BaseModal
      title="Choose an icon"
      onClose={onClose}
      isOpen={isOpen}
    >
      <Grid container spacing={1}>
        {
          FEATHER_ICONS.map((iconName: string) => (
            <Grid item xs={3}>
              <Box
                className={classes.iconBox}
                onClick={() => {
                  handleSelectIcon(iconName);
                  onClose();
                }}
              >
                <SvgIcon>
                  <IconRenderer iconName={iconName} />
                </SvgIcon>
                <Box mt={1}>
                  <Typography variant="subtitle1">
                    {iconName}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))
        }
      </Grid>
    </BaseModal>
  );
};

export default FeatherIconPicker;
